import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  bold: {
    fontWeight: 'bold',
  },
  container: {
    marginTop: theme.spacing(8),
    width: '100%',
    maxWidth: (p) => (p.isMobile ? '100%' : '75%'),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
    },
  },
}));

export default useStyles;
